export const PAYMENT_PREFS = [
  { value: "faturali", label: "Faturalı" },
  { value: "kesintili", label: "Kesintili Hesap" },
  { value: "nakit", label: "Nakit" },
  { value: "diger", label: "Diğer" },
];

export const BILLING_STATUSES = [
  { value: "zamani_gelmedi", label: "Zamanı Gelmedi", dot: "bg-slate-400", chip: "bg-slate-100 text-slate-700 border-slate-200" },
  { value: "odeme_talep_edildi", label: "Ödeme Talep Edildi", dot: "bg-amber-500", chip: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "odedi", label: "Ödedi", dot: "bg-emerald-500", chip: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { value: "kismi_odeme", label: "Kısmi Ödeme", dot: "bg-sky-500", chip: "bg-sky-50 text-sky-700 border-sky-200" },
  { value: "odemedi", label: "Ödemedi", dot: "bg-red-500", chip: "bg-red-50 text-red-600 border-red-200" },
];

export const BILLING_METHODS = [
  { value: "faturali", label: "Faturalı" },
  { value: "nakit", label: "Nakit" },
  { value: "muafiyet", label: "Muafiyet Hesabı" },
  { value: "diger", label: "Diğer" },
];

export const ONETIME_JOB_STATUSES = [
  { value: "on_odeme_bekleniyor", label: "Ön Ödeme Bekleniyor" },
  { value: "on_odeme_alindi", label: "Ön Ödeme Alındı" },
  { value: "devam_ediyor", label: "Devam Ediyor" },
  { value: "tamamlandi", label: "Tamamlandı" },
  { value: "odeme_bekleniyor", label: "Ödeme Bekleniyor" },
  { value: "odeme_yapildi", label: "Ödeme Yapıldı" },
];

export const FIXED_EXPENSE_ITEMS = [
  { key: "aylik_cekim", label: "Aylık Çekim" },
  { key: "aylik_reklamci", label: "Aylık Reklamcı" },
  { key: "aylik_yazilim", label: "Aylık Yazılım" },
  { key: "aylik_diger", label: "Aylık Diğer" },
];

export const ONETIME_FIXED_EXPENSE_ITEMS = [
  { key: "aylik_cekim", label: "Çekim" },
  { key: "aylik_reklamci", label: "Reklamcı" },
  { key: "aylik_yazilim", label: "Yazılım" },
  { key: "aylik_diger", label: "Diğer" },
];

export const EXPENSE_ITEMS = [
  "Tasarım", "Video Çekimi", "Yazılım", "Reklam Yönetimi",
  "Program Gideri", "Yapay Zeka", "Diğer",
];

export const MONTHS_TR = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık",
];

export const fmtTL = (v) => {
  if (v == null || Number.isNaN(v)) return "—";
  return `${new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(v)} ₺`;
};

export const billingStatusMeta = (v) => BILLING_STATUSES.find((s) => s.value === v) || BILLING_STATUSES[0];
export const onetimeStatusMeta = (v) => ONETIME_JOB_STATUSES.find((s) => s.value === v);
export const paymentMethodLabel = (v) => BILLING_METHODS.find((m) => m.value === v)?.label || "—";

export const fmtDateTR = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
};

export const monthLabel = (year, month) => `${MONTHS_TR[month - 1]} ${year}`;
